import { Injectable } from "@angular/core";
import { PortService } from "./port/port.service";
import { Geoserver } from "./geoserver/model/geoserver";
import "leaflet";
import "leaflet-wfst";
import "rxjs/Rx";
import "rxjs/add/operator/toPromise";
import "leaflet-wfst";
import "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/images/marker-icon.png";
import "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/images/marker-icon.png";
import { tokengeoserver } from "./geoserver/tokengeoserver";
import { TranslateService } from "@ngx-translate/core";
import { Http } from "@angular/http";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
declare var L: any;

@Injectable()
export class MapService {
  public map: L.Map;
  public baseMaps: any;
  public mywms: any;
  public layerlrm2: any;
  private vtLayer: any;
  public layerport: any;
  public greenIcon: any;
  public urlGeoserver: Geoserver;
  tokenGeoservertiles: string =
    tokengeoserver.GeosrverProtocolHttps +
    tokengeoserver.GeoserverTile +
    tokengeoserver.GeoservertokenServer;
  tokengeoserverServer: string = tokengeoserver.GeoserverFR;

  tokenGeoservertilesEN: string =
    tokengeoserver.GeosrverProtocolHttps +
    tokengeoserver.GeoserverTileEN +
    tokengeoserver.GeoserverWFSEN +
    tokengeoserver.GeoserverTIFEN;

  tokenTiff: string = tokengeoserver.GeoserverTIF;
  public boundary: any;
  public portMarseille: any;
  toggle: boolean = false;
  curentLang: string;
  tileLang: string;

  constructor(
    public http: Http,
    public portsService: PortService,
    public translate: TranslateService
  ) {
    this.curentLang = translate.getBrowserLang();

    let geoserverURL;
    this.portsService.getGeoserverUrl().subscribe(data => {
      this.urlGeoserver = data;
    });

    if (this.curentLang == "fr") {
      this.tileLang = "/osmfr/";
    } else this.tileLang = "en";

    var treeIconList = L.icon({
      iconUrl: "assets/marker-icon.png"
    });
    var treeIconHvoya = L.icon({
      iconUrl: "assets/marker-icon.png"
    });
    const osmAttr = "OSM";
    this.baseMaps = {
      OpenStreetMapEN: L.tileLayer(this.tokenGeoservertilesEN, {
        zIndex: 1,
        attribution: "OSM-EN"
      })
    };

    var crossIcon = L.icon({
      iconUrl: "assets/red.png",
      shadowUrl: "assets/red.png",
      iconSize: [11, 11],
      shadowSize: [11, 11],
      iconAnchor: [6, 6],
      shadowAnchor: [5, 5],
      popupAnchor: [5, 5]
    });

    this.greenIcon = L.icon({
      iconUrl: "assets/marker-icon.png",
      iconSize: [26, 34] // size of the icon
    });
  }

  /*
    changeLangueGeoServeur(langue:string){
      if (langue == "fr") {
        this.tileLang = "/osmfr/";
      } else this.tileLang = "en";
  
    }
  */

  disableMouseEvent() {
    //fonction du lancement de trigger
    function onEachFeature(feature, layer) {
      //Affichage du popup quand on clique sur un marker
      layer.bindPopup(
        '<table> <tr><th> </th></tr>  <tr>  <td><img src="assets/red.png"/> </td><td style="color:red;">' +
          feature.properties.nom +
          '</td></tr><tr>  <td><img src="assets/images/flags/fr.png"  /> </td><td>' +
          feature.properties.pays +
          "</td></tr></table>"
      );
      //Affichage du marker en couleu vert
      layer.on("popupopen", function(e) {
        this.AFFICHER_RESULTAT1 = true;
        this.nav.onClickMe();
      });
      // this.portName = feature.properties.nom;
      //Afichage du marker en couleur rouge
      layer.on("popupclose", function(e) {});
    }

    var greenIcon = L.icon({
      iconUrl: "assets/marker-icon.png",
      iconSize: [26, 34] // size of the icon
    });

    var redIcon = L.icon({
      iconUrl: "assets/red.png", //le chemein vers l'icone
      iconSize: [26, 34] // taille de l icone
    });

    var blueIcon = L.icon({
      iconUrl: "assets/current.png", //le chemein vers l'icone
      iconSize: [26, 34] // taille de l icone
    });
    var aa = 0;
  }

  disableMouseEventb() {
    //fonction du lancement de trigger
  }

  toggleMarkerEditing(on: boolean) {
    if (on) {
      this.map.on("click", this.addMarker.bind(this));
    } else {
      this.map.off("click");
    }
  }

  fitBounds(bounds: L.LatLngBounds) {
    this.map.fitBounds(bounds, {});
  }

  private addMarker(e: L.LeafletMouseEvent) {
    const shortLat = Math.round(e.latlng.lat * 1000000) / 1000000;
    const shortLng = Math.round(e.latlng.lng * 1000000) / 1000000;
    const popup = `<div>Latitude: ${shortLat}<div><div>Longitude: ${shortLng}<div>`;
    const icon = L.icon({
      iconUrl: "assets/marker-icon.png",
      shadowUrl: "assets/marker-shadow.png"
    });

    const marker = L.marker(e.latlng, {
      draggable: true,
      icon
    })
      .bindPopup(popup, {
        offset: L.point(12, 6)
      })
      .addTo(this.map)
      .openPopup();

    marker.on("click", () => marker.remove());
  }

  //Create constructor to get Http instance

  getClientLocation() {
    if (window.location.protocol != "https:") {
      return this.http.get("http://ipinfo.io/json").map(this.extractData);
      //  return this.http.get("https://ipinfo.io/json").map(this.extractData);
    } else {
      return this.http.get("https://ipinfo.io/json").map(this.extractData);
    }
  }

  protected extractData(res: Response | any) {
    let body: any = res.json();

    return body;
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/map.service.ts